import { useState } from "react"
import Field from "./components/Field"
import Players from "./components/Players"
import { PlayerSet } from "./utils"
import { IPlayer } from "./types"
import Results from "./components/Results"
import Prestart from "./components/Prestart"

const players = new PlayerSet(6, 4)
	// .add(name, team, seasonFinish, bracketFinish, isConsolationBracket)
	.add("Jonathan", "TEN", 1, 2)
	.add("Stephen", "BAL", 2, 4)
	.add("Anthony", "BUF", 6, 6)
	.add("Larry", "NYG", 9, 3, true)
	.add("Nick", "CHI", 3, 1)
	.add("Ryan", "MIN", 8, 1, true)
	.add("Kiran", "NYG", 4, 5)
	.add("Jeremy", "CHI", 10, 2, true)
	.add("Daniel", "CHI")
	.add("Grey", "BUF")
	.done()

const App = () => {
	const [raceActive, setRaceActive] = useState(false)
	const [results, setResults] = useState<IPlayer[]>([])

	return (
		<>
			<Field>
				<Players
					players={players}
					raceActive={raceActive}
					onFinish={(players) => {
						setRaceActive(false)
						setResults(players)
					}}
				/>
			</Field>

			<Prestart show={!raceActive && !results.length} players={players} onStartRace={() => setRaceActive(true)} />

			<Results results={results} />
		</>
	)
}

export default App
